import React from 'react'
import NewFormDialogModel from '../../formsSystem/NewFormDialogModel'
import { Tooltip } from '@mui/material'
import WindowProps from '../../windowViewer/WindowProps'
import RemoveProjectContributorDialogContent from './RemoveProjectContributorComps/RemoveProjectContributorDialogContent'
import withStyles from '@mui/styles/withStyles'
import { GiBrokenHeart } from 'react-icons/gi'
import i18next from 'i18next'

const styles = () => ({
  icon: {
    cursor: 'pointer',
    fontSize: 18,
    '&:hover': {
      opacity: 0.8,
    },
  },
  iconWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
  },
})

const RemoveProjectContributor = ({ classes, noFSPanelProps }) => {
  const { showEndContribution } = noFSPanelProps
  const { isWindowOpen, windowOpener, windowCloser } = WindowProps()
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <>
      <Tooltip title={rtl ? 'انهاء التشارك' : 'End Contribution'}>
        <span
          className={classes.iconWrapper}
          style={{ display: showEndContribution ? null : 'none' }}
          onClick={() => windowOpener()}
        >
          <GiBrokenHeart className={classes.icon} />
        </span>
      </Tooltip>
      <NewFormDialogModel
        NewFormComponent={
          <RemoveProjectContributorDialogContent
            noFSPanelProps={noFSPanelProps}
            windowCloser={windowCloser}
          />
        }
        newFormDialogClose={windowCloser}
        isNewFormDialogOpen={isWindowOpen}
        {...noFSPanelProps}
        clickAwayState={true}
        dialogTitle={rtl ? 'انهاء مشاركة' : 'End Contribution'}
      />
    </>
  )
}

const WrappedRemoveProjectContributor = withStyles(styles)(
  RemoveProjectContributor
)

export default WrappedRemoveProjectContributor
